import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'chevron-left', 'IconChevronLeft', [["path",{"d":"M15 6l-6 6l6 6","key":"svg-0"}]]);